function Footer()
{
    return(
        <div>
            <hr/>
            <div className="text-center">
                All Rights Reserved Copyrights {new Date().getFullYear()}
            </div>
        </div>
    );
}
export default Footer;